import styled, { css } from 'styled-components';
import { COLORS, FONTS } from './../../ui';

interface Props {
  width?: string;
  fullWidth?: boolean;
  error?: boolean;
  disabled?: boolean;
}

export const Wrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: ${(props: Props) => props.fullWidth ? '100%' : props.width};
  font-family: ${FONTS.ROBOTO_REGULAR};

  ${(props: Props) => props.disabled && css`
    pointer-events: none;

    ${Box} {
      opacity: 0.3;
    }
  `}
`;

Wrapper.displayName = 'Wrapper';

export const DatePickerIcon = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  z-index: 1;

  ${(props: Props) => props.error && css`
    svg {
      color: black;
    }
  `}
`;

DatePickerIcon.displayName = 'Icon';

export const Box = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 0;
  color: ${COLORS.BLACK};
  font-size: 14px;
`;

Box.displayName = 'Box';

export const Input = styled.input`
  background-color: transparent;
  width: 100%;
  height: 40px;
  padding: 12px 30px 12px 12px;
  border: 2px solid ${COLORS.BORDER_GRAY};
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  z-index: 2;
  font-size: 14px;

  &::placeholder {
    font-family: ${FONTS.ROBOTO_REGULAR};
  }
  &:focus {
    outline: none;
    border: 2px solid ${COLORS.AQUA_BLUE};
  }

  ${(props: Props) => props.error && css`
    border: 2px solid ${COLORS.ERROR_RED};
  `}

  &:focus ~ ${DatePickerIcon} {
    svg {
      color: black;
    }
  }
`;

Input.displayName = 'Input';


